import {css} from 'lit';
export const styles = css`:host {
  display: block;
  color: var(--text-primary);
  background-color: var(--contrast-light);
}

:host(:not(:last-child)) {
  border-bottom: 1px solid var(--border-dark);
}

main {
  display: flex;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 16px;
}

ef-avatar {
  margin-right: 16px;
  align-self: flex-start;
}

div {
  flex: 1;
  min-width: 0;
  margin-right: 16px;
}

div > *,
ef-label {
  display: block;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

h4 {
  margin-top: 2px;
  margin-bottom: 2px;
  line-height: normal;
}

h4[focus-within] {
  outline: 1px solid var(--link-focus-outline);
  outline-offset: var(--link-focus-outline-offset);
}

h4:focus-within {
  outline: 1px solid var(--link-focus-outline);
  outline-offset: var(--link-focus-outline-offset);
}

h4 ef-online-status {
  margin-left: 4px;
}

h4 a:focus {
  outline: none;
}

ef-label {
  padding: 4px;
  margin-bottom: 2px;
  font-size: 0.8em;
  transition: opacity ease-in-out 200ms;
}

div > a:active > ef-label {
  opacity: 1;
}

time {
  font-size: var(--font-size-base);
}

button {
  display: flex;
  padding: 4px 8px;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 16px;
  background-color: transparent;
  color: inherit;
}

button:active {
  background-color: var(--border-dark);
}

button > span {
  margin-right: 4px;
}

button ef-icon {
  font-size: 18px;
}

@media (hover: hover) {
  ef-label:hover {
    opacity: 0.7;
  }

  button:hover {
    background-color: var(--border-primary);
  }

  button:active {
    background-color: var(--border-dark);
  }
}

@media (max-width: 767px) {
  :host {
    --font-size-base: 12px;
    --font-size-lg: 14px;
  }
}

@media (max-width: 500px) {
  button {
    padding: 0;
    width: 32px;
    height: 32px;
    background-color: var(--border-primary);
  }

  button > span {
    display: none;
  }

  button > ef-icon {
    border-radius: 50%;
  }
}
`;
export default styles;
